import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdminGuard } from './guards/admin.guard';
import { AuthGuard } from './guards/auth.guard';
import { MainComponent } from './main/main.component';
import { PageNotFoundComponent } from './shared/page-not-found/page-not-found.component';

const routes: Routes = [
  {
    path: 'main',
    component: MainComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'gestao-orcamentaria',
        loadChildren: () =>
          import('./licitacao/licitacao.module').then((m) => m.LicitacaoModule),
      },
      {
        path: 'operacao',
        loadChildren: () =>
          import('./operacao/operacao.module').then((m) => m.OperacaoModule),
      },
      {
        path: 'pils',
        loadChildren: () =>
          import('./operacao/pil_cadastros/pil.module').then(
            (m) => m.PilModule
          ),
      },
      {
        path: 'rh',
        loadChildren: () => import('./rh/rh.module').then((m) => m.RhModule),
      },
      {
        path: 'financeiro',
        loadChildren: () =>
          import('./financeiro/financeiro.module').then(
            (m) => m.FinanceiroModule
          ),
      },
      {
        path: 'compras',
        loadChildren: () =>
          import('./compras/compras.module').then((m) => m.ComprasModule),
      },
      {
        path: 'inventory',
        loadChildren: () =>
          import('./inventory/inventory.module').then((m) => m.InventoryModule),
      },
      {
        path: 'convenios',
        loadChildren: () =>
          import('./convenios/convenios.module').then((m) => m.ConveniosModule),
      },
      {
        path: 'ti',
        loadChildren: () => import('./ti/ti.module').then((m) => m.TiModule),
      },
      {
        path: 'responsavel',
        loadChildren: () =>
          import('./responsavel/responsavel.module').then(
            (m) => m.ResponsavelModule
          ),
      },
      {
        path: 'farmacia',
        loadChildren: () =>
          import('./farmacia/farmacia.module').then((m) => m.FarmaciaModule),
      },
      {
        path: 'chat',
        loadChildren: () =>
          import('./chat/chat.module').then((m) => m.ChatModule),
      },
      {
        path: 'protocolo',
        loadChildren: () =>
          import('./protocolo/protocolo.module').then((m) => m.ProtocoloModule),
      },
      {
        path: 'tutorials',
        loadChildren: () =>
          import('./tutorial/tutorial.module').then((m) => m.TutorialModule),
      },
      {
        path: 'ti/dashboard',
        canActivate: [AdminGuard],
        loadChildren: () =>
          import('./chat/ti-dashboard/ti-dashboard.module').then(
            (m) => m.TiDashboardModule
          ),
      },

      // End Point

      // ADMINISTRADOR
      {
        path: 'users-access',
        canActivate: [AdminGuard],
        loadChildren: () =>
          import(
            './administrador/acesso/usuario-acesso/usuario-acesso.module'
          ).then((m) => m.UsuarioAcessoModule),
      },
      {
        path: 'companies',
        canActivate: [AdminGuard],
        loadChildren: () =>
          import('./administrador/empresa/empresa.module').then(
            (m) => m.EmpresaModule
          ),
      },
      {
        path: 'notifications',
        loadChildren: () =>
          import('./administrador/notificacao/notificacao.module').then(
            (m) => m.NotificacaoModule
          ),
      },
      //  END ADMINISTRADOR

      //COOPERATIVE
      {
        path: 'cooperative',
        loadChildren: () =>
          import('./licitacao/cooperative-area/cooperative-area.module').then(
            (m) => m.CooperativeAreaModule
          ),
      },

      // AGENDAMENTOS
      {
        path: 'calendar-room-meeting',
        loadChildren: () =>
          import('./agendamento/calendario/calendario.module').then(
            (m) => m.CalendarioModule
          ),
      },
      {
        path: 'meeting-rooms',
        loadChildren: () =>
          import('./agendamento/sala-reuniao/sala-reuniao.module').then(
            (m) => m.SalaReuniaoModule
          ),
      },
      // END AGENDAMENTOS

      // ALTERAR-SENHA
      {
        path: 'change-password',
        loadChildren: () =>
          import('./alterar-senha/alterar-senha.module').then(
            (m) => m.AlterarSenhaModule
          ),
      },
      // END ALTERAR-SENHA

      // COMPRAS
      {
        path: 'quotations',
        loadChildren: () =>
          import('./compras/cotacao/cotacao.module').then(
            (m) => m.CotacaoModule
          ),
      },
      // estoque
      {
        path: 'stock/entries',
        loadChildren: () =>
          import('./compras/estoque/entrada/entrada.module').then(
            (m) => m.EntradaModule
          ),
      },
      {
        path: 'stock/products',
        loadChildren: () =>
          import(
            './compras/estoque/estoque-produto/estoque-produto.module'
          ).then((m) => m.EstoqueProdutoModule),
      },
      {
        path: 'stock/reports',
        loadChildren: () =>
          import('./compras/estoque/relatorio/relatorio.module').then(
            (m) => m.RelatorioModule
          ),
      },
      {
        path: 'stock/exits',
        loadChildren: () =>
          import('./compras/estoque/saida/saida.module').then(
            (m) => m.SaidaModule
          ),
      },
      {
        path: 'mat-med',
        loadChildren: () => import('./mat-med/mat-med.module')
          .then((m) => m.MatMedModule)
      },
      // end estoque
      {
        path: 'suppliers',
        loadChildren: () =>
          import('./compras/fornecedores/fornecedores.module').then(
            (m) => m.FornecedoresModule
          ),
      },
      {
        path: 'leases',
        loadChildren: () =>
          import('./compras/locacao/locacao.module').then(
            (m) => m.LocacaoModule
          ),
      },
      {
        path: 'purchase-orders',
        loadChildren: () =>
          import('./compras/pedido-compra/pedido-compra.module').then(
            (m) => m.PedidoCompraModule
          ),
      },
      {
        path: 'products',
        loadChildren: () =>
          import('./compras/product/product.module').then(
            (m) => m.ProductModule
          ),
      },
      {
        path: 'kit',
        loadChildren: () =>
          import('./compras/kit/kit.module').then(
            (m) => m.KitModule
          ),
      },
      {
        path: 'material-requisition',
        loadChildren: () =>
          import(
            './compras/requisicao-material/requisicao-material.module'
          ).then((m) => m.RequisicaoMaterialModule),
      },
      // END COMPRAS

      // CONVENIOS
      {
        path: 'insurence/reports',
        loadChildren: () =>
          import('./convenios/relatorios/relatorios.module').then(
            (m) => m.RelatoriosModule
          ),
      },
      {
        path: 'insurence/metering',
        loadChildren: () =>
          import('./convenios/new-medicao/new-medicao.module').then(
            (m) => m.NewMedicaoModule
          ),
      },
      {
        path: 'insurence/manual-documents',
        loadChildren: () =>
          import(
            './convenios/new-documento-manual/new-documento-manual.module'
          ).then((m) => m.NewDocumentoManualModule),
      },
      {
        path: 'insurence/monitoring',
        loadChildren: () =>
          import('./convenios/new-monitoramento/new-monitoramento.module').then(
            (m) => m.NewMonitoramentoModule
          ),
      },
      // END CONVENIOS

      // FINANCEIRO
      {
        path: 'categories-natures',
        loadChildren: () =>
          import(
            './financeiro/categoria-natureza/categoria-natureza.module'
          ).then((m) => m.CategoriaNaturezaModule),
      },
      {
        path: 'bank-accounts',
        loadChildren: () =>
          import('./financeiro/conta-bancaria/conta-bancaria.module').then(
            (m) => m.ContaBancariaModule
          ),
      },
      {
        path: 'accounts',
        loadChildren: () =>
          import('./financeiro/contas/contas.module').then(
            (m) => m.ContasModule
          ),
      },
      {
        path: 'purchasing-quotations',
        loadChildren: () =>
          import('./financeiro/cotacoes/cotacoes.module').then(
            (m) => m.CotacoesModule
          ),
      },
      // diretoria
      {
        path: 'directors/company',
        loadChildren: () =>
          import('./financeiro/diretoria/empresas/empresas.module').then(
            (m) => m.EmpresasModule
          ),
      },
      {
        path: 'directors/approve-payments',
        loadChildren: () =>
          import(
            './financeiro/diretoria/aprovar-pagamento/aprovar-pagamento.module'
          ).then((m) => m.AprovarPagamentoModule),
      },
      // end diretoria
      {
        path: 'cash-flows',
        loadChildren: () =>
          import('./financeiro/fluxo-de-caixa/fluxo-de-caixa.module').then(
            (m) => m.FluxoDeCaixaModule
          ),
      },
      {
        path: 'cash-flows',
        loadChildren: () =>
          import('./financeiro/fluxo-de-caixa/fluxo-de-caixa.module').then(
            (m) => m.FluxoDeCaixaModule
          ),
      },
      {
        path: 'natures',
        loadChildren: () =>
          import('./financeiro/natureza/natureza.module').then(
            (m) => m.NaturezaModule
          ),
      },
      {
        path: 'metering',
        loadChildren: () =>
          import('./financeiro/new-medicao/new-medicao.module').then(
            (m) => m.NewMedicaoModule
          ),
      },
      {
        path: 'tiss',
        loadChildren: () =>
          import('./financeiro/new-tiss/new-tiss.module').then(
            (m) => m.NewTissModule
          ),
      },
      {
        path: 'cnab-payments',
        loadChildren: () =>
          import('./financeiro/pagamentos/pagamentos.module').then(
            (m) => m.PagamentosModule
          ),
      },
      {
        path: 'pix-payments',
        loadChildren: () =>
          import('./financeiro/pix/pix-payments.module').then(
            (m) => m.PixPaymentsModule
          ),
      },
      {
        path: 'financial/reports',
        loadChildren: () =>
          import(
            './financeiro/relatorio-financeiro/relatorio-financeiro.module'
          ).then((m) => m.RelatorioFinanceiroModule),
      },
      // END FINANCEIRO

      //Faturamento
      {
        path: 'billing',
        loadChildren: () =>
          import('./licitacao/billing/billing.module').then(
            (m) => m.BillingModule
          ),
      },

      // HOME
      {
        path: 'home',
        loadChildren: () =>
          import('./home/home.module').then((m) => m.HomeModule),
      },
      // END HOME

      // INVENTORY
      {
        path: 'entry-single',
        loadChildren: () =>
          import('./inventory/entry/entry.module').then((m) => m.EntryModule),
      },
      {
        path: 'material-requisitions',
        loadChildren: () =>
          import(
            './inventory/material-requisition/material-requisition.module'
          ).then((m) => m.MaterialRequisitionModule),
      },
      {
        path: 'output-single',
        loadChildren: () =>
          import('./inventory/output/output.module').then(
            (m) => m.OutputModule
          ),
      },
      // END INVENTORY

      // LICITACAO
      {
        path: 'budgets',
        loadChildren: () =>
          import('./licitacao/budgets/budgets.module').then(
            (m) => m.BudgetsModule
          ),
      },
      {
        path: 'clients',
        loadChildren: () =>
          import('./licitacao/cliente/cliente.module').then(
            (m) => m.ClienteModule
          ),
      },
      {
        path: 'contracts',
        loadChildren: () =>
          import('./licitacao/contract/contract.module').then(
            (m) => m.ContractModule
          ),
      },
      {
        path: 'customer-area',
        loadChildren: () =>
          import('./licitacao/customer-screen/customer-screen.module').then(
            (m) => m.CustomerScreenModule
          ),
      },
      {
        path: 'costs',
        loadChildren: () =>
          import('./licitacao/custos/custos.module').then(
            (m) => m.CustosModule
          ),
      },
      {
        path: 'taxes',
        loadChildren: () =>
          import('./licitacao/imposto/imposto.module').then(
            (m) => m.ImpostoModule
          ),
      },
      {
        path: 'patients',
        loadChildren: () =>
          import('./licitacao/paciente/paciente.module').then(
            (m) => m.PacienteModule
          ),
      },
      {
        path: 'packages',
        loadChildren: () =>
          import('./licitacao/package/package.module').then(
            (m) => m.PackageModule
          ),
      },
      {
        path: 'responsibles',
        loadChildren: () =>
          import('./licitacao/responsavel/responsavel.module').then(
            (m) => m.ResponsavelModule
          ),
      },
      {
        path: 'services',
        loadChildren: () =>
          import('./licitacao/servico/servico.module').then(
            (m) => m.ServicoModule
          ),
      },
      {
        path: 'tables',
        loadChildren: () =>
          import('./licitacao/tabelas/tabelas.module').then(
            (m) => m.TabelasModule
          ),
      },
      {
        path: 'bidding/dashboard',
        loadChildren: () =>
          import('./licitacao/visao-geral/visao-geral.module').then(
            (m) => m.VisaoGeralModule
          ),
      },
      {
        path: 'claim-management',
        loadChildren: () =>
          import('./licitacao/claim-management/claim-management.module').then(
            (m) => m.ClaimManagementModule
          ),
      },
      // END LICITACAO

      //  MEU-PERFIL
      {
        path: 'my-profile',
        loadChildren: () =>
          import('./meu-perfil/meu-perfil.module').then(
            (m) => m.MeuPerfilModule
          ),
      },
      // END MEU-PERFIL

      // OPERACAO
      {
        path: 'bore-clearance',
        loadChildren: () =>
          import('./operacao/bore-clearance/bore-clearance.module').then(
            (m) => m.BoreClearanceModule
          ),
      },
      {
        path: 'document-categories',
        loadChildren: () =>
          import(
            './operacao/categoria-documentos/categoria-documentos.module'
          ).then((m) => m.CategoriaDocumentosModule),
      },
      {
        path: 'cares',
        loadChildren: () =>
          import('./operacao/cuidado/cuidado.module').then(
            (m) => m.CuidadoModule
          ),
      },
      {
        path: 'clinical-area/dashboard',
        loadChildren: () =>
          import('./operacao/dashboard/dashboard.module').then(
            (m) => m.DashboardModule
          ),
      },
      {
        path: 'documents',
        loadChildren: () =>
          import('./operacao/documents/documents.module').then(
            (m) => m.DocumentsModule
          ),
      },
      {
        path: 'scales',
        loadChildren: () =>
          import('./operacao/escala/escala.module').then((m) => m.EscalaModule),
      },
      {
        path: 'patient-screen',
        loadChildren: () =>
          import('./operacao/escala/tela-paciente/tela-paciente.module').then(
            (m) => m.TelaPacienteModule
          ),
      },
      {
        path: 'general-reports',
        loadChildren: () =>
          import('./operacao/general-reports/general-reports.module').then(
            (m) => m.GeneralReportsModule
          ),
      },
      {
        path: 'care-groups',
        loadChildren: () =>
          import('./operacao/grupo-cuidado/grupo-cuidado.module').then(
            (m) => m.GrupoCuidadoModule
          ),
      },
      {
        path: 'monitoring',
        loadChildren: () =>
          import('./operacao/monitoring/monitoring.module').then(
            (m) => m.MonitoringModule
          ),
      },
      {
        path: 'supplier-reports',
        loadChildren: () =>
          import(
            './operacao/relatorio-prestador/relatorio-prestador.module'
          ).then((m) => m.RelatorioPrestadorModule),
      },
      {
        path: 'medication-transcripts',
        loadChildren: () =>
          import(
            './operacao/transcription-medication/transcription-medication.module'
          ).then((m) => m.TranscriptionMedicationModule),
      },
      // END OPERACAO

      // RESPONSAVEL
      {
        path: 'responsible/patients',
        loadChildren: () =>
          import('./responsavel/list-patients/list-patients.module').then(
            (m) => m.ListPatientsModule
          ),
      },
      {
        path: 'responsible/monitoring',
        loadChildren: () =>
          import(
            './responsavel/monitoring-patients/monitoring-patients.module'
          ).then((m) => m.MonitoringPatientsModule),
      },
      {
        path: 'responsible/signatures',
        loadChildren: () =>
          import(
            './responsavel/signature-responsible/signature-responsible.module'
          ).then((m) => m.SignatureResponsibleModule),
      },

      // RH
      {
        path: 'base-professionals',
        loadChildren: () =>
          import('./rh/base-profissional/base-profissional.module').then(
            (m) => m.BaseProfissionalModule
          ),
      },
      {
        path: 'auxiliary-records',
        loadChildren: () =>
          import('./rh/cadastro-auxiliar/cadastro-auxiliar.module').then(
            (m) => m.CadastroAuxiliarModule
          ),
      },
      {
        path: 'external-electronic-points',
        loadChildren: () =>
          import(
            './rh/external-electronic-point/external-electronic-point.module'
          ).then((m) => m.ExternalElectronicPointModule),
      },
      {
        path: 'payrolls',
        loadChildren: () =>
          import('./rh/folha-pagamento/folha-pagamento.module').then(
            (m) => m.FolhaPagamentoModule
          ),
      },
      {
        path: 'outer-sheets',
        loadChildren: () =>
          import('./rh/outer-sheet/outer-sheet.module').then(
            (m) => m.OuterSheetModule
          ),
      },
      {
        path: 'service-providers',
        loadChildren: () =>
          import('./rh/prestador-servico/prestador-servico.module').then(
            (m) => m.PrestadorServicoModule
          ),
      },
      {
        path: 'professionals',
        loadChildren: () =>
          import('./rh/profissional/profissional.module').then(
            (m) => m.ProfissionalModule
          ),
      },
      {
        path: 'reports-providers',
        loadChildren: () =>
          import('./rh/reports-providers/reports-providers.module').then(
            (m) => m.ReportsProvidersModule
          ),
      },
      {
        path: 'users',
        loadChildren: () =>
          import('./rh/usuarios/usuarios.module').then((m) => m.UsuariosModule),
      },
      {
        path: 'overview',
        loadChildren: () =>
          import('./rh/visao-geral/visao-geral.module').then(
            (m) => m.VisaoGeralModule
          ),
      },
      // END RH

      {
        path: 'area-clinica',
        loadChildren: () =>
          import('./area-clinica/area-clinica.module').then(
            (m) => m.AreaClinicaModule
          ),
      },

      {
        path: 'auditoria',
        loadChildren: () =>
          import('./auditoria/auditoria.module').then((m) => m.AuditoriaModule),
      },
    ],
  },
  { path: '', redirectTo: '/main/home', pathMatch: 'full' },
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.module').then((m) => m.AuthModule),
  },
  // END LOGIN
  { path: '**', component: PageNotFoundComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
